<style>
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Perfil
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Notificação</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-8">
                  <button class="btn btn-primary" @click="openModal()">
                    Novo <i class="fas fa-plus" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="col-4">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar"
                    /><span class="input-group-text text-body"
                      ><i
                        class="fas fa-search"
                        aria-hidden="true"
                        style="cursor: pointer"
                      ></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        #
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Titulo
                      </th>

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                      >
                        Visualizado
                      </th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Status
                      </th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Data de criação
                      </th>
                      <th class="text-secondary opacity-7"></th>
                      <th class="text-secondary opacity-7"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="data in notificacoes" :key="data.id">
                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <a
                              href="javascript:;"
                              class="text-secondary font-weight-bold text-xs"
                              data-toggle="tooltip"
                              data-original-title="{{data.titulo}}"
                              @click.prevent="exibirNotificao(data)"
                            >
                              <h6 class="mb-0 text-sm">{{ data.id }}</h6>
                            </a>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">{{ data.titulo }}</h6>
                          </div>
                        </div>
                      </td>
                      {{ visualizacoes(data.id) }}
                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">{{ checkVisualizacoes(data.id) }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span
                          class="badge badge-sm"
                          :class="
                            data.status == 'ativo'
                              ? 'bg-gradient-success'
                              : data.status == 'desativado'
                              ? 'bg-gradient-danger'
                              : 'bg-gradient-warning'
                          "
                        >
                          {{ data.status }}</span
                        >
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          formatarData(data.created_at)
                        }}</span>
                      </td>
                      <td class="align-middle">
                        <a
                          :href=" route('admin.notificacao.detalhes', {id: data}) "
                          class="text-secondary font-weight-bold text-xs"
                          data-toggle="tooltip"
                          data-original-title="Detalhes Notificação"                    
                          >Detalhes
                        </a>
                      </td>
                      <td class="align-middle">
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs"
                          data-toggle="tooltip"
                          data-original-title="Edit Notificação"
                          @click.prevent="edit(data)"
                          >Editar
                        </a>
                      </td>
                      
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <nav aria-label="navigation">
                <ul class="pagination pagination-primary">
                  <li class="page-item disabled">
                    <a class="page-link" href="">«</a>
                  </li>
                  <li class="page-item active">
                    <a
                      class="page-link"
                      href="http://localhost:8000/admin/usuarios?page=1"
                      >1</a
                    >
                  </li>
                  <li class="page-item disabled">
                    <a class="page-link" href="">»</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div
        class="modal fade"
        id="modalNotify"
        tabindex="-1"
        aria-labelledby="modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <form @submit.prevent="checkMode">
              <div class="modal-header">
                <h5 class="modal-title" id="modalLabel">{{ formTitle }}</h5>
                <span
                  style="cursor: pointer"
                  @click="closeModal"
                  aria-label="Close"
                  aria-hidden="true"
                  >×</span
                >
              </div>

              <div class="modal-body">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Titulo</label
                    >
                    <input
                      v-model="form.titulo"
                      class="form-control"
                      type="text"
                      onfocus="focused(this)"
                      onfocusout="defocused(this)"
                      :class="{ 'is-invalid': form.errors.titulo }"
                    />
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.titulo }"
                  >
                    {{ form.errors.titulo }}
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Descrição</label
                    >
                    <textarea
                      v-model="form.conteudo"
                      class="form-control"
                      onfocus="focused(this)"
                      onfocusout="defocused(this)"
                      :class="{ 'is-invalid': form.errors.conteudo }"
                      rows="4"
                    >
                    </textarea>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.conteudo }"
                  >
                    {{ form.errors.conteudo }}
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Status</label
                    >
                    <select
                      id="status"
                      class="form-control"
                      v-model="form.status"
                    >
                      <option value="ativo">Ativo</option>
                      <option value="desativado" v-if="editMode">
                        Bloqueado
                      </option>
                      <option value="rascunho">Rascunho</option>
                    </select>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.status }"
                  >
                    {{ form.errors.status }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >Enviar para</label
                      >
                      <select
                        id="set_grupo_one"
                        class="form-control"
                        v-model="set_tipo"
                      >
                        <option value="">Escolher</option>
                        <option value="prefeituras">Prefeituras</option>
                        <option value="lojistas">Lojistas</option>
                        <option value="clientes">Clientes</option>
                      </select>
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.set_tipo }"
                    >
                      {{ form.errors.set_tipo }}
                    </div>
                  </div>

                  <div
                    class="col-md-2"
                    v-if="set_tipo == 'prefeituras' || set_tipo == 'lojistas'"
                  >
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >Prefeituras</label
                      >
                      <select
                        id="set_grupo_prox"
                        class="form-control"
                        v-model="set_prefeitura"
                      >
                        <option value="all">Todos</option>
                        <option
                          v-for="prefeitura in prefeituras"
                          :key="prefeitura.id"
                          :value="prefeitura.id"
                        >
                          {{ prefeitura.descricao }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.set_prefeitura }"
                    >
                      {{ form.errors.set_prefeitura }}
                    </div>
                  </div>

                  <div class="col-md-2" v-if="set_tipo == 'lojistas'">
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >Lojistas</label
                      >
                      <select
                        id="set_lojista"
                        class="form-control"
                        v-model="form.set_lojista"
                      >
                        <option value="all">Todos</option>
                        <option
                          v-for="lojista in lojistas"
                          :key="lojista.id"
                          :value="lojista.id"
                        >
                          {{ lojista.name }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.set_lojista }"
                    >
                      {{ form.errors.set_lojista }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="closeModal"
                >
                  Fechar
                </button>
                <button type="submit" class="btn btn-success">
                  {{ buttonTxt }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Modal 2-->
      <div
        class="modal fade"
        id="modalNotifyExibir"
        tabindex="-1"
        aria-labelledby="modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-sx">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="modalLabel">{{ form.titulo }}</h4>
              <span
                style="cursor: pointer"
                @click="closeModal2"
                aria-label="Close"
                aria-hidden="true"
                >×</span
              >
            </div>

            <div class="modal-body">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Descrição</label
                  >

                  <h5>
                    {{ form.conteudo }}
                  </h5>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.conteudo }"
                >
                  {{ form.errors.conteudo }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Enviado para:</label
                  >

                  <h5>
                    <div v-for="item in notificacoes" :key="item.id">
                      <!-- {{ item}} -->
                      <div
                        v-for="item2 in item.notificacao_env"
                        :key="item2.id"
                      >
                        <li v-if="item2.notificacao_id == form.id" style="list-style: none;">
                          {{ checkUser(item2.user_id, form.id) }}
                          <span class="badge badge-sm bg-gradient-success">
                            {{ checkEnvios(item2.user_id).user }} 
                          </span>
                          - 
                          <span class="badge badge-sm bg-gradient-success">
                            {{ checkEnvios(item2.user_id).prefeitura }}
                          </span>
                           - 
                           
                           <span class="badge badge-sm " :class="
                            checkEnvios(item2.user_id).status == 'lido'
                              ? 'bg-gradient-success'
                              : checkEnvios(item2.user_id).status == 'nao_lido'
                              ? 'bg-gradient-danger'
                              : 'bg-gradient-warning'
                          ">
                            {{ checkEnvios(item2.user_id).status == 'lido'
                              ? 'Lido'
                              : checkEnvios(item2.user_id).status == 'nao_lido'
                              ? 'Não lido'
                              : 'Não visualizado' }}
                          </span>
                        </li>
                      </div>
                    </div>
                  </h5>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.conteudo }"
                >
                  {{ form.errors.conteudo }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeModal2"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Components/Pagination";
import moment from "moment";
import axios from "axios";

export default {
  props: ["user", "notificacoes", "prefeituras", "usuarios"],
  components: {
    AdminLayout,
    Pagination,
    moment,
  },

  data() {
    return {
      modal: Object,
      modal2: Object,
      users: [],
      prefeitura: [],
      lojistas: [],
      visualizados: [],
      enviados: [],
      set_tipo: "",
      set_prefeitura: "",


      roleOptions: this.roles,
      filter: "",
      editMode: false,

      form: this.$inertia.form({
        titulo: "",
        conteudo: "",
        img: "",
        link: "",
        status: "ativo",
        set_tipo: "",
        set_prefeitura: "",
        set_lojista: "",
      }),
    };
  },

  computed: {
    formTitle() {
      return this.editMode === false
        ? "Adicionar Notificação"
        : "Editar Notificação";
    },
    buttonTxt() {
      return this.editMode === false ? "Salvar" : "Editar";
    },
    checkMode() {
      return this.editMode === false ? this.create : this.update;
    },
    
  },

  watch: {
    set_prefeitura: function (val) {
      this.list_lojistras(val);
      this.form.set_prefeitura = val;
    },


    set_tipo: function (val) {
      if (val == "prefeituras") {
        this.form.set_lojista = "";
        this.form.set_tipo = val;
      }
      if (val == "clientes") {
        this.form.set_lojista = "";
        this.set_prefeitura = "";
        this.form.set_tipo = val;
      }
      if (val == "lojistas") {
        this.form.set_lojista = "";
        this.set_prefeitura = "";
        this.form.set_tipo = val;
      }
    },
  },

  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },

    list_lojistras(id) {
      axios.get("/api/notificacao/" + id).then((response) => {
        this.lojistas = response.data;
      });
    },

    visualizacoes(id) {
      axios.get("/api/notificacaos/vizualizacoes/" + id).then((response) => {    
        //se não exitir o id no array visualizados, adiciona
        if (this.checkVisualizacoes(id) == undefined) {
          this.visualizados.push([id, response.data]);
        }
        
        // console.log(this.visualizados);       
       
      });
    },

    checkVisualizacoes(id) {
      for (var p in this.visualizados) {
        if (id == this.visualizados[p][0]) {
          return this.visualizados[p][1];
        }
      }      
    },

    checkPrefeitura(id) {
      for (var p in this.prefeitura) {
        if (id == this.prefeitura[p].id) {
          return this.prefeitura[p].descricao;
        }
        
      }
    },

    checkUser(id_user, id_notificacao) {
      axios.get("/api/notificacaos/checkusuario/" + id_user + "/" + id_notificacao).then((response) => {      
        if (this.checkEnvios(id_user) == undefined) {         
          this.enviados.push([id_user, response.data]);
        }

      });
            
    },

    async checkEnvios(id) {
      for (var p in this.enviados) {
        if (id == this.enviados[p][0]) {
          return this.enviados[p][1];
        }
      }      
    },

    openModal() {
      this.editMode = false;
      this.form.clearErrors();
      this.modal.show();
      this.form.reset();
      this.set_tipo = "";
      this.set_prefeitura = "";
      this.set_lojista = "";
    },

    openModal2() {
      this.editMode = false;
      this.form.clearErrors();
      this.modal2.show();
      this.form.reset();
    },

    closeModal2() {
      this.modal2.hide();
      this.form.clearErrors();
      this.editMode = false;
    },

    closeModal() {
      this.modal.hide();
      this.form.clearErrors();
      this.editMode = false;
    },

    create() {
      this.form.post(this.route("admin.notificacao.store"), {
        preserveScroll: true,
        onSuccess: () => {
          this.closeModal();
          this.form.reset();
          this.set_prefeitura = "";
          this.set_lojista = "";
        },
      });
    },
    edit(user) {
      this.openModal();
      this.editMode = true;

      console.log("Editar Notificação");
      console.log(user);

      this.form = Object.assign(this.form, user);

      // this.form.role = await user.roles[0];
    },

    //MORRER
    exibirNotificao(user) {
      this.openModal2();
      this.editMode = true;

      console.log("Exibir Notificação");
      console.log(user);

      this.form = Object.assign(this.form, user);
    },

    update() {
      this.form.patch(
        this.route("admin.notificacao.update", this.form.id, this.form),
        {
          preserveScroll: true,
          onSuccess: () => {
            this.closeModal();
            this.form.reset();
          },
        }
      );
    },
  },

  async mounted() {
    axios.get("/api/notificacao/prefeituras").then((response) => {
      this.prefeitura = response.data;
    });

    this.modal = new bootstrap.Modal(
      document.getElementById("modalNotify"),
      {}
    );

    this.modal2 = new bootstrap.Modal(
      document.getElementById("modalNotifyExibir"),
      {}
    );
  },
};
</script>

